import { render } from "./BookingDetail.vue?vue&type=template&id=c293066c&scoped=true"
import script from "./BookingDetail.vue?vue&type=script&lang=js"
export * from "./BookingDetail.vue?vue&type=script&lang=js"

import "./BookingDetail.vue?vue&type=style&index=0&id=c293066c&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c293066c"]])

export default __exports__